// tabOne
import dklogo from "../../images/homeRowFuncLogos/dkLogo.svg";
import dkJetLogo from "../../images/homeRowFuncLogos/dkJet.svg";
import dkBuisinessLogo from "../../images/homeRowFuncLogos/dkBusiness.svg";
import fidiboLogo from "../../images/homeRowFuncLogos/fidibo.svg";
import diigStyleLogo from "../../images/homeRowFuncLogos/digiStyle.svg";
import digiFyLogo from "../../images/homeRowFuncLogos/digify.svg";
import dkMehrLogo from "../../images/homeRowFuncLogos/dkMehr.svg";
import bomimahaliLogo from "../../images/homeRowFuncLogos/bomimahali.svg";
import komodaLogo from "../../images/homeRowFuncLogos/komoda.svg";
import pindoLogo from "../../images/homeRowFuncLogos/pindo.svg";

// tabTow
import dkMagLogo from "../../images/homeRowFuncLogos/dkMagLogo.svg";
import contentFactoryLogo from "../../images/homeRowFuncLogos/contentFactoryLogo.svg";
import selerAcademyLogo from "../../images/homeRowFuncLogos/selerAcademyLogo.svg";
import magnetLogo from "../../images/homeRowFuncLogos/magnetLogo.svg";

// tab 3
import dkExpress from "../../images/homeRowFuncLogos/dkExpress.svg";
import ganj from "../../images/homeRowFuncLogos/ganj.svg";
import timeLogo from "../../images/homeRowFuncLogos/timeLogo.svg";

// tab 4
import payLogo from "../../images/homeRowFuncLogos/payLogo.svg";

// tab 5
import nextLogo from "../../images/homeRowFuncLogos/nextLogo.svg";

// tab 6
import smartTech from "../../images/homeRowFuncLogos/smartTech.svg";

// tab 7
import dkcloud from "../../images/homeRowFuncLogos/dkcloud.svg";

import { sharedData } from "./sharedData";

export const statisticTitle = [
	{
		title: "تجارت الکترونیک",
		id: 1,
	},
	{
		title: "محتوا",
		id: 2,
	},
	{
		title: "لجستیک",
		id: 3,
	},
	{
		title: "فناوری مالی",
		id: 4,
	},
	{
		title: "بومی محلی",
		id: 5,
	},
	// {
	//   title: "اشتغال‌زایی",
	//   id: 6
	// }
];
export const statisticTitleEn = [
	{
		title: "E-commerce",
		id: 1,
	},
	{
		title: "Content",
		id: 2,
	},
	{
		title: "Logistics",
		id: 3,
	},
	{
		title: "Financial Technology",
		id: 4,
	},
	{
		title: "Native and Local Businesses",
		id: 5,
	},
	// {
	//   title: "Job Creation",
	//   id: 6
	// }
];

export const statisticData = [
	{
		id: 1,
		statisticList: [
			{
				number: "5/6",
				unit: "میلیون",
				describe: "بازدیدکننده روزانه",
				unitEn: "Million",
				describeEn: "Average Daily Visitors",
			},
			{
				number: "15/3",
				unit: "میلیون",
				describe: "تنوع کالایی در دیجی‌کالا",
				unitEn: "Million",
				describeEn: "SKUs at Digikala",
			},
			{
				number: "426",
				unit: "هزار",
				describe: "فروشنده در دیجی‌کالا",
				unitEn: "Thousand",
				describeEn: "Sellers at Digikala",
			},
			{
				number: "4/4",
				unit: "میلیون",
				describe: "متوسط جست‌وجوی روزانه کالا",
				unitEn: "Million",
				describeEn: "Average Daily Product Search",
			},
			{
				number: "5/2",
				unit: "میلیون",
				describe: "مشتری در شهرهایی غیر از تهران",
				unitEn: "Million",
				describeEn: "Customers in Non-Tehran Cities",
			},
			{
				number: "10",
				unit: "هزار",
				describe: "پرسنل در دیجی‌کالا",
				unitEn: "Thousand",
				describeEn: "Employees at Digikala",
			},
			// {
			//   number: "25",
			//   unit: "هزار",
			//   describe: "فروشگاه فعال در پیندو",
			//   unitEn: "Thousand",
			//   describeEn: "Active store in Pindo",
			// },
			// {
			//   number: "+17",
			//   unit: "هزار",
			//   describe: "سفارش روزانه در دیجی‌کالا جت",
			//   unitEn: "Thousand",
			//   describeEn: "Daily orders in DigikalaJet",
			// },
		],
		logosList: [
			{
				logo: dklogo,
				link: `https://www.digikala.com/${sharedData.utmParams}`,
				linkEn: `https://www.digikala.com/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},

			{
				logo: dkJetLogo,
				link: `https://www.digikalajet.com/${sharedData.utmParams}`,
				linkEn: `https://www.digikalajet.com/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},
			{
				logo: dkBuisinessLogo,
				link: `https://www.digikalabusiness.com/${sharedData.utmParams}`,
				linkEn: `https://www.digikalabusiness.com/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},
			{
				logo: fidiboLogo,
				link: `https://fidibo.com/${sharedData.utmParams}`,
				linkEn: `https://fidibo.com/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},
			{
				logo: diigStyleLogo,
				link: `https://www.digistyle.com/${sharedData.utmParams}`,
				linkEn: `https://www.digistyle.com/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},
			{
				logo: digiFyLogo,
				link: `https://digify.shop/${sharedData.utmParams}`,
				linkEn: `https://digify.shop/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},
			{
				logo: dkMehrLogo,
				link: `https://www.digikala.com/mehr/${sharedData.utmParams}`,
				linkEn: `https://www.digikala.com/mehr/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},
			{
				logo: bomimahaliLogo,
				link: `https://www.digikala.com/landings/village-businesses/${sharedData.utmParams}`,
				linkEn: `https://www.digikala.com/landings/village-businesses/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},
			// {
			//   logo: komodaLogo,
			//   link: `https://www.komodaa.com/${sharedData.utmParams}`,
			//   linkEn: `https://www.komodaa.com/${sharedData.utmParamsEn}`,
			//   isActive: true,
			//   scale: 1
			// },
			{
				logo: pindoLogo,
				link: `https://www.pindo.ir/${sharedData.utmParams}`,
				linkEn: `https://www.pindo.ir/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},
		],
	},
	{
		id: 2,
		statisticList: [
			{
				number: "66",
				unit: "میلیون",
				describe: "نظر منتشر شده کاربران دیجی‌کالا",
				unitEn: "Million",
				describeEn: "Published User Comments",
			},
			{
				number: "137",
				unit: "میلیون",
				describe: "مجموع بازدید از ویدیوهای مگنت در صفحات کالا",
				unitEn: "Million",
				describeEn: "Magnet Vidoes Total Visit at Product Pages",
			},
			{
				number: "15/1",
				unit: "هزار",
				describe: "ویدیوی منتشر شده توسط کاربران",
				unitEn: "Thousand",
				describeEn: "Published User Generated Videos",
			},
			{
				number: "43",
				unit: "هزار",
				describe: "ویدیوی منتشر شده بررسی کالا",
				unitEn: "Thousand",
				describeEn: "Published Product Review Videos",
			},
			{
				number: "3/8",
				unit: "میلیون",
				describe: "محتوای تولید شده برای کالاها",
				unitEn: "Million",
				describeEn: "Created Content for Products",
			},
		],
		logosList: [
			{
				logo: dkMagLogo,
				link: `https://www.digikala.com/mag/${sharedData.utmParams}`,
				linkEn: `https://www.digikala.com/mag/${sharedData.utmParamsEn}`,

				isActive: true,
				scale: 1,
			},
			{
				logo: contentFactoryLogo,
				link: `https://www.digikala.com/contentfactory/${sharedData.utmParams}`,
				linkEn: `https://www.digikala.com/contentfactory/${sharedData.utmParamsEn}`,

				isActive: true,
				scale: 1,
			},
			{
				logo: selerAcademyLogo,
				link: `https://selleracademy.digikala.com/${sharedData.utmParams}`,
				linkEn: `https://selleracademy.digikala.com/${sharedData.utmParamsEn}`,

				isActive: true,
				scale: 1,
			},
			{
				logo: magnetLogo,
				link: `https://www.digikala.com/landings/magnet/${sharedData.utmParams}`,
				linkEn: `https://www.digikala.com/landings/magnet/${sharedData.utmParamsEn}`,

				isActive: true,
				scale: 1,
			},
		],
	},
	{
		id: 3,
		statisticList: [
			{
				number: "6/1",
				unit: "میلیون",
				describe: "ظرفیت انبارش کالا در دیجی‌کالا",
				unitEn: "Million",
				describeEn: "Product Item Storage Capacity at Digikala",
			},
			{
				number: "1",
				unit: "میلیون",
				describe: "ظرفیت روزانه پردازش کالا در دیجی‌کالا",
				unitEn: "Million",
				describeEn: "Product Item Fulfilment Capacity at Digikala",
			},
			{
				number: "959",
				unit: "",
				describe: "مرکز زیرساختی دیجی‌کالا در سراسر کشور",
				unitEn: "",
				describeEn: "Infrastructural Centers of Digikala across the Country",
			},
			// {
			//   number: "+14",
			//   unit: "هزار",
			//   describe: "راننده خویش فرما در دیجی‌اکسپرس",
			//   unitEn: "Thousands",
			//   describeEn: "of self-employed drivers in Digiexpress",
			// },
			{
				number: "84/3",
				unit: "درصد",
				describe: "میانگین ماهانه سفارش توزیع شده توسط دیجی‌اکسپرس",
				unitEn: "Percentage",
				describeEn: "Average Monthly Orders Delivered by DigiExpress",
			},
			{
				number: "95/1",
				unit: "درصد",
				describe: "نرخ ارسال به‌موقع سفارش‌ها",
				unitEn: "Percentage",
				describeEn: "On-Time Delivery Rate",
			},
			{
				number: "731",
				unit: "",
				describe: "مرکز تحویل حضوری",
				unitEn: "",
				describeEn: "Physical Delivery Centers",
			},
			{
				number: "1/8",
				unit: "میلیون",
				describe: "سفارش‌هایی که حضوری تحویل شده‌اند",
				unitEn: "Million",
				describeEn: "Physical Delivery Orders",
			},
		],
		logosList: [
			{
				logo: dkExpress,
				link: `https://digiexpress.ir/${sharedData.utmParams}`,
				linkEn: `https://digiexpress.ir/${sharedData.utmParamsEn}`,

				isActive: true,
				scale: 1,
			},
			{
				logo: ganj,
				link: `https://ganje.net/${sharedData.utmParams}`,
				linkEn: `https://ganje.net/${sharedData.utmParamsEn}`,

				isActive: true,
				scale: 1,
			},
			{
				logo: timeLogo,
				link: `https://optimeai.com/${sharedData.utmParams}`,
				linkEn: `https://optimeai.com/${sharedData.utmParamsEn}`,

				isActive: true,
				scale: 1,
			},
		],
	},
	{
		id: 4,
		statisticList: [
			{
				number: "20",
				unit: "درصد",
				describe: "سهم خرید اعتباری چهار قسطه از تعداد کالاهای فروخته شده",
				unitEn: "Percentage",
				describeEn: "Share of 1 Pay Purchases from Total Sales",
			},
			{
				number: "7/3",
				unit: "درصد",
				describe: "سهم خرید اعتباری یک قسطه از تعداد کالاهای فروخته شده",
				unitEn: "Percentage",
				describeEn: "Share of 4 Pay Purchases from Total Sales",
			},
			// {
			//   number: "182",
			//   unit: "هزار",
			//   describe: "کاربرانی که از دیجی‌کالا خرید اقساطی داشتند",
			//   unitEn: "Thousand",
			//   describeEn: "Users with BNPL at Digikala",
			// }
		],
		logosList: [
			{
				logo: payLogo,
				link: `https://www.mydigipay.com/${sharedData.utmParams}`,
				linkEn: `https://www.mydigipay.com/${sharedData.utmParamsEn}`,

				isActive: true,
				scale: 1,
			},
		],
	},
	{
		id: 5,
		statisticList: [
			{
				number: "18/2",
				unit: "هزار",
				describe: "فروشنده بومی و محلی",
				unitEn: "Thousand",
				describeEn: "Local and Native Sellers",
			},
			// {
			//   number: "60",
			//   unit: "هزار",
			//   describe: "تنوع کالایی محصولات بومی و محلی",
			//   unitEn: "Thousand",
			//   describeEn: "Local and Native Product SKUs",
			// },
			// {
			//   number: "12",
			//   unit: "میلیارد تومان",
			//   describe: "متوسط فروش سالانه پرفروش‌ترین فروشنده بومی‌محلی",
			//   unitEn: "Billion Tomans",
			//   describeEn: "Average Annual Sales of Most Successful Local and Native Seller",
			// },
			{
				number: "81/500",
				unit: "کالا",
				describe:
					"میانگین تعداد کالاهای فروخته‌شده توسط فروشندگان بومی‌محلی در هر ماه",
				unitEn: "Product",
				describeEn: "Average Monthly Sales of Local and Native Sellers",
			},
			{
				number: "155",
				unit: "میلیون تومان",
				describe: "میانگین فروش فروشندگان بومی‌محلی",
				unitEn: "Million Tomans",
				describeEn: "Average Monthly Sales of Local and Native Sellers",
			},
		],
		logosList: [
			{
				logo: bomimahaliLogo,
				link: `https://www.digikala.com/landings/village-businesses/${sharedData.utmParams}`,
				linkEn: `https://www.digikala.com/landings/village-businesses/${sharedData.utmParamsEn}`,
				isActive: true,
				scale: 1,
			},
		],
	},
	// {
	//   id: 6,
	//   statisticList: [
	//     {
	//       number: "1/3",
	//       unit: "میلیون",
	//       describe: "شغل ایجاد شده در دیجی‌کالا در طول ۱۷ سال (همکاران دیجی‌کالا و فروشندگان)",
	//       unitEn: "Million",
	//       describeEn: "Jobs Created by Digikala in 17 Years (Digikala Employees and Sellers)",
	//     },
	//     {
	//       number: "42",
	//       unit: "هزار",
	//       describe: "پرسنل دیجی‌کالا در طول ۱۷ سال",
	//       unitEn: "Thousand",
	//       describeEn: "Digikala Total Employees in 17 Years",
	//     },
	//     {
	//       number: "1/2",
	//       unit: "میلیون",
	//       describe: "شغل ایجاد شده توسط دیجی‌کالا در طول ۷ سال فعالیت بازار آنلاین",
	//       unitEn: "Million",
	//       describeEn: "Job Created by Digikala in 7 Years of Online Market Activity",
	//     }
	//   ],
	//   logosList: [
	//     {
	//       logo: dklogo,
	//       link: `https://www.digikala.com/${sharedData.utmParams}`,
	//       linkEn: `https://www.digikala.com/${sharedData.utmParamsEn}`,
	//       isActive: true,
	//       scale: 1,
	//     },
	//   ]
	// }
	// {
	//   id: 5,
	//   statisticList: [
	//     {
	//       number: "22",
	//       unit: "",
	//       describe: "استارتاپ فعال در دیجی‌نکست",
	//       unitEn: "",
	//       describeEn: "Startups Active at DigiNext",
	//     },
	//     {
	//       number: "2",
	//       unit: "",
	//       describe: "محصول بر لبه تکنولوژی دیجی‌نکست",
	//       unitEn: "",
	//       describeEn: "Cutting Edge Technology Products at DigiNext",
	//     },
	//     {
	//       number: "44",
	//       unit: "",
	//       describe: "استارتاپ سرمایه گذاری شده در دیجی‌نکست",
	//       unitEn: "",
	//       describeEn: "Startups Invested On at DigiNext",
	//     },
	//   ],
	//   logosList: [
	//     {
	//       logo: nextLogo,
	//       link: `https://diginext.ai/${sharedData.utmParams}`,
	//       linkEn: `https://diginext.ai/${sharedData.utmParamsEn}`,

	//       isActive: true,
	//       scale: 1,
	//     },
	//   ],
	// },
	// {
	//   id: 6,
	//   statisticList: [
	//     {
	//       number: "1/1",
	//       unit: "میلیارد",
	//       describe: "مجموع پیام‌های ارسال شده در inTrack",
	//       unitEn: "Billion",
	//       describeEn: "Messages Sent at inTrack",
	//     },
	//     {
	//       number: "327",
	//       unit: "",
	//       describe: "رسانه فعال در Afillio",
	//       unitEn: "",
	//       describeEn: "Active Media at Afillio",
	//     },
	//     {
	//       number: "16",
	//       unit: "هزار",
	//       describe: "کمپین اجرا شده در AdVerge",
	//       unitEn: "Thousand",
	//       describeEn: "Campaigns Ran at AdVerge",
	//     },
	//   ],
	//   logosList: [
	//     {
	//       logo: smartTech,
	//       link: `https://smartech.ir/${sharedData.utmParams}`,
	//       linkEn: `https://smartech.ir/${sharedData.utmParamsEn}`,

	//       isActive: true,
	//       scale: 1,
	//     },
	//   ],
	// },
	// {
	//   id: 7,
	//   statisticList: [
	//     {
	//       number: "17",
	//       unit: "",
	//       describe: "شرکت مشتری خدمات دیجی‌کلاد",
	//       unitEn: "",
	//       describeEn: "Businesses Getting Service from DigiCloud",
	//     },
	//   ],
	//   logosList: [
	//     {
	//       logo: dkcloud,
	//       link: "",
	//       linkEn: "",

	//       isActive: false,
	//     },
	//   ],
	// },
];

// ========================= OLD
// ========================= OLD
// ========================= OLD
// ========================= OLD
// ========================= OLD
// ========================= OLD
// ========================= OLD
// ========================= OLD
// ========================= OLD

//
// // tabOne
// import dklogo from "../../images/homeRowFuncLogos/dkLogo.svg";
// import dkJetLogo from "../../images/homeRowFuncLogos/dkJet.svg";
// import dkBuisinessLogo from "../../images/homeRowFuncLogos/dkBusiness.svg";
// import fidiboLogo from "../../images/homeRowFuncLogos/fidibo.svg";
// import diigStyleLogo from "../../images/homeRowFuncLogos/digiStyle.svg";
// import digiFyLogo from "../../images/homeRowFuncLogos/digify.svg";
// import dkMehrLogo from "../../images/homeRowFuncLogos/dkMehr.svg";
// import bomimahaliLogo from "../../images/homeRowFuncLogos/bomimahali.svg";
// import komodaLogo from "../../images/homeRowFuncLogos/komoda.svg";
// import pindoLogo from "../../images/homeRowFuncLogos/pindo.svg";
//
// // tabTow
// import dkMagLogo from "../../images/homeRowFuncLogos/dkMagLogo.svg";
// import contentFactoryLogo from "../../images/homeRowFuncLogos/contentFactoryLogo.svg";
// import selerAcademyLogo from "../../images/homeRowFuncLogos/selerAcademyLogo.svg";
// import magnetLogo from "../../images/homeRowFuncLogos/magnetLogo.svg";
//
// // tab 3
// import dkExpress from "../../images/homeRowFuncLogos/dkExpress.svg";
// import ganj from "../../images/homeRowFuncLogos/ganj.svg";
// import timeLogo from "../../images/homeRowFuncLogos/timeLogo.svg";
//
// // tab 4
// import payLogo from "../../images/homeRowFuncLogos/payLogo.svg";
//
// // tab 5
// import nextLogo from "../../images/homeRowFuncLogos/nextLogo.svg";
//
// // tab 6
// import smartTech from "../../images/homeRowFuncLogos/smartTech.svg";
//
// // tab 7
// import dkcloud from "../../images/homeRowFuncLogos/dkcloud.svg";
//
// import { sharedData } from "./sharedData";
//
// export const statisticTitle = [
//     {
//         title: "تجارت الکترونیک",
//         id: 1,
//     },
//     {
//         title: "محتوا",
//         id: 2,
//     },
//     {
//         title: "لجستیک",
//         id: 3,
//     },
//     {
//         title: "فناوری مالی",
//         id: 4,
//     },
//     {
//         title: "نوآوری",
//         id: 5,
//     },
//     {
//         title: "فناوری بازاریابی",
//         id: 6,
//     },
//     {
//         title: "فناوری ابری",
//         id: 7,
//     },
// ];
// export const statisticTitleEn = [
//     {
//         title: "electronic commerce",
//         id: 1,
//     },
//     {
//         title: "content",
//         id: 2,
//     },
//     {
//         title: "logistic",
//         id: 3,
//     },
//     {
//         title: "financial technology",
//         id: 4,
//     },
//     {
//         title: "Innovation",
//         id: 5,
//     },
//     {
//         title: "Marketing technology",
//         id: 6,
//     },
//     {
//         title: "Cloud technology",
//         id: 7,
//     },
// ];
//
// export const statisticData = [
//     {
//         id: 1,
//         statisticList: [
//             {
//                 number: "+40",
//                 unit: "میلیون",
//                 describe: "کاربر فعال ماهانه در دیجی‌کالا",
//                 unitEn: "Million",
//                 describeEn: "Monthly active user in Digikala",
//             },
//             {
//                 number: "+9",
//                 unit: "میلیون",
//                 describe: "تنوع کالایی در دیجی‌کالا",
//                 unitEn: "Million",
//                 describeEn: "Product variety in Digikala",
//             },
//             {
//                 number: "+300",
//                 unit: "هزار",
//                 describe: "فروشنده در دیجی‌کالا",
//                 unitEn: "Thousand",
//                 describeEn: "Seller in Digikala",
//             },
//             {
//                 number: "+130",
//                 unit: "هزار",
//                 describe: "عنوان محتوا در فیدیبو",
//                 unitEn: "Thousand",
//                 describeEn: "Titles of content in Fidibo",
//             },
//             {
//                 number: "+9",
//                 unit: "هزار",
//                 describe: "پرسنل در دیجی‌کالا",
//                 unitEn: "Thousand",
//                 describeEn: "Titles of content in Fidibo",
//             },
//             // {
//             //   number: "+17",
//             //   unit: "هزار",
//             //   describe: "سفارش روزانه در دیجی‌کالا جت",
//             //   unitEn: "Thousand",
//             //   describeEn: "Daily orders in DigikalaJet",
//             // },
//         ],
//         logosList: [
//             {
//                 logo: dklogo,
//                 link: `https://www.digikala.com/${sharedData.utmParams}`,
//                 linkEn: `https://www.digikala.com/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//
//             {
//                 logo: dkJetLogo,
//                 link: `https://www.digikalajet.com/${sharedData.utmParams}`,
//                 linkEn: `https://www.digikalajet.com/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: dkBuisinessLogo,
//                 link: `https://www.digikalabusiness.com/${sharedData.utmParams}`,
//                 linkEn: `https://www.digikalabusiness.com/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: fidiboLogo,
//                 link: `https://fidibo.com/${sharedData.utmParams}`,
//                 linkEn: `https://fidibo.com/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: diigStyleLogo,
//                 link: `https://www.digistyle.com/${sharedData.utmParams}`,
//                 linkEn: `https://www.digistyle.com/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: digiFyLogo,
//                 link: `https://digify.shop/${sharedData.utmParams}`,
//                 linkEn: `https://digify.shop/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: dkMehrLogo,
//                 link: `https://www.digikala.com/mehr/${sharedData.utmParams}`,
//                 linkEn: `https://www.digikala.com/mehr/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: bomimahaliLogo,
//                 link: `https://www.digikala.com/landings/village-businesses/${sharedData.utmParams}`,
//                 linkEn: `https://www.digikala.com/landings/village-businesses/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: komodaLogo,
//                 link: `https://www.komodaa.com/${sharedData.utmParams}`,
//                 linkEn: `https://www.komodaa.com/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: pindoLogo,
//                 link: `https://www.pindo.ir/${sharedData.utmParams}`,
//                 linkEn: `https://www.pindo.ir/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//         ],
//     },
//     {
//         id: 2,
//         statisticList: [
//             {
//                 number: "+32",
//                 unit: "میلیون",
//                 describe: "محتوای تولید شده توسط کاربران دیجی‌کالا",
//                 unitEn: "Million",
//                 describeEn: "of content produced by DigiKala users",
//             },
//             {
//                 number: "+20",
//                 unit: "میلیون",
//                 describe: "بازدید ماهانه از بلاگ‌های دیجی‌کالا مگ",
//                 unitEn: "Million",
//                 describeEn: "of monthly visits to Digikala Mag blogs",
//             },
//             {
//                 number: "+164",
//                 unit: "هزار",
//                 describe: "محتوای تولید شده توسط کاربران در مگنت",
//                 unitEn: "Thousands",
//                 describeEn: "of content generated by users in Magnet",
//             },
//             {
//                 number: "+5000",
//                 unit: "",
//                 describe: "فروشنده بهره‌مند از خدمات کارخانه محتوا",
//                 unitEn: "",
//                 describeEn: "Seller benefiting from content factory services",
//             },
//             {
//                 number: "+950",
//                 unit: "",
//                 describe: "ویدیو منتشر شده در دیجی‌کالا مگ",
//                 unitEn: "",
//                 describeEn: "Video published in Digikala Mag",
//             },
//         ],
//         logosList: [
//             {
//                 logo: dkMagLogo,
//                 link: `https://www.digikala.com/mag/${sharedData.utmParams}`,
//                 linkEn: `https://www.digikala.com/mag/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: contentFactoryLogo,
//                 link: `https://www.digikala.com/contentfactory/${sharedData.utmParams}`,
//                 linkEn: `https://www.digikala.com/contentfactory/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: selerAcademyLogo,
//                 link: `https://selleracademy.digikala.com/${sharedData.utmParams}`,
//                 linkEn: `https://selleracademy.digikala.com/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: magnetLogo,
//                 link: `https://www.digikala.com/landings/magnet/${sharedData.utmParams}`,
//                 linkEn: `https://www.digikala.com/landings/magnet/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//         ],
//     },
//     {
//         id: 3,
//         statisticList: [
//             {
//                 number: "+7/5",
//                 unit: "میلیون",
//                 describe: "ظرفیت انبارش کالا در دیجی‌کالا",
//                 unitEn: "Million",
//                 describeEn: "of storage capacities in DigiKala",
//             },
//             {
//                 number: "+960",
//                 unit: "هزار",
//                 describe: "ظرفیت روزانه پردازش کالا در دیجی‌کالا",
//                 unitEn: "Thousands",
//                 describeEn: "daily capacity of goods processing in DigiKala",
//             },
//             {
//                 number: "126",
//                 unit: "",
//                 describe: "مرکز زیرساختی دیجی‌کالا",
//                 unitEn: "",
//                 describeEn: "Digikala infrastructure center",
//             },
//             {
//                 number: "+14",
//                 unit: "هزار",
//                 describe: "راننده خویش فرما در دیجی‌اکسپرس",
//                 unitEn: "Thousands",
//                 describeEn: "of self-employed drivers in Digiexpress",
//             },
//         ],
//         logosList: [
//             {
//                 logo: dkExpress,
//                 link: `https://digiexpress.ir/${sharedData.utmParams}`,
//                 linkEn: `https://digiexpress.ir/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: ganj,
//                 link: `https://ganje.net/${sharedData.utmParams}`,
//                 linkEn: `https://ganje.net/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//             {
//                 logo: timeLogo,
//                 link: `https://optimeai.com/${sharedData.utmParams}`,
//                 linkEn: `https://optimeai.com/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//         ],
//     },
//     {
//         id: 4,
//         statisticList: [
//             {
//                 number: "15",
//                 unit: "میلیارد تومان",
//                 describe: "اعتبار BNPL اختصاص یافته به کاربران دیجی‌پی",
//                 unitEn: "billion tomans",
//                 describeEn: "of BNPL credit allocated to DigiP users",
//             },
//             {
//                 number: "1",
//                 unit: "میلیارد تومان",
//                 describe: "اعتبار تخصیص داده شده به کاربران دیجی‌پی",
//                 unitEn: "Billion Tomans",
//                 describeEn: "of credits allocated to DigiP users",
//             },
//             {
//                 number: "+700",
//                 unit: "هزار میلیون تومان",
//                 describe: "کل تراکنش‌های سالانه کیف پول",
//                 unitEn: "One thousand million tomans",
//                 describeEn: "total annual wallet transactions",
//             },
//             {
//                 number: "+28",
//                 unit: "میلیارد تومان",
//                 describe: "تراکنش از درگاه‌های پرداخت دیجی‌پی",
//                 unitEn: "billion tomans",
//                 describeEn: "of transactions from DigiP payment gateways",
//             },
//         ],
//         logosList: [
//             {
//                 logo: payLogo,
//                 link: `https://www.mydigipay.com/${sharedData.utmParams}`,
//                 linkEn: `https://www.mydigipay.com/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//         ],
//     },
//     {
//         id: 5,
//         statisticList: [
//             {
//                 number: "25",
//                 unit: "",
//                 describe: "استارتاپ فعال در دیجی‌نکست",
//                 unitEn: "",
//                 describeEn: "Startup active in Diginext",
//             },
//             {
//                 number: "5",
//                 unit: "",
//                 describe: "محصول بر لبه تکنولوژی دیجی‌نکست",
//                 unitEn: "",
//                 describeEn: "The product is on the edge of Diginext technology",
//             },
//             {
//                 number: "49",
//                 unit: "",
//                 describe: "استارتاپ سرمایه گذاری شده در دیجی‌نکست",
//                 unitEn: "",
//                 describeEn: "Startup invested in Diginext",
//             },
//         ],
//         logosList: [
//             {
//                 logo: nextLogo,
//                 link: `https://diginext.ai/${sharedData.utmParams}`,
//                 linkEn: `https://diginext.ai/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//         ],
//     },
//     {
//         id: 6,
//         statisticList: [
//             {
//                 number: "+250",
//                 unit: "میلیون",
//                 describe: "مجموع پیام‌های ارسال شده در inTrack",
//                 unitEn: "Million",
//                 describeEn: "of total messages sent on inTrack",
//             },
//             {
//                 number: "+2150",
//                 unit: "",
//                 describe: "رسانه فعال در Afillio",
//                 unitEn: "",
//                 describeEn: "Active media in Afillio",
//             },
//             {
//                 number: "1075",
//                 unit: "",
//                 describe: "کمپین اجرا شده در AdVerge",
//                 unitEn: "",
//                 describeEn: "campaigns run on AdVerge",
//             },
//         ],
//         logosList: [
//             {
//                 logo: smartTech,
//                 link: `https://smartech.ir/${sharedData.utmParams}`,
//                 linkEn: `https://smartech.ir/${sharedData.utmParamsEn}`,
//
//                 isActive: true, scale: 1,
//             },
//         ],
//     },
//     {
//         id: 7,
//         statisticList: [
//             {
//                 number: "17",
//                 unit: "",
//                 describe: "شرکت مشتری خدمات دیجی‌کلاد",
//                 unitEn: "",
//                 describeEn: "Digicloud service client company",
//             },
//         ],
//         logosList: [
//             {
//                 logo: dkcloud,
//                 link: "",
//                 linkEn: "",
//
//                 isActive: false,
//             },
//         ],
//     },
// ];
